export default "__VITE_ASSET__DVNAaQ9S__"